import { render, staticRenderFns } from "./DiagnoseStartPage.vue?vue&type=template&id=6446a3ce"
import script from "./DiagnoseStartPage.vue?vue&type=script&lang=js"
export * from "./DiagnoseStartPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports